import { CSSProperties, useMemo } from 'react';

import omit from 'lodash/omit';

import { useResponsive } from '@lumapps/responsive';
import { INNER_SPACING_STYLES, OUTER_SPACING_STYLES } from '@lumapps/widget-styles/constants';
import { AllStyles, ShorthandProperties } from '@lumapps/widget-styles/types';
import { computeStyles } from '@lumapps/widget-styles/utils/computeStyles';

export function useComputeStyles(
    styles: AllStyles | string | undefined,
    shouldRemoveSpacingOnMobile = false,
): Omit<CSSProperties, ShorthandProperties> | undefined {
    const { isMobile } = useResponsive();

    return useMemo(() => {
        const computedStyles = computeStyles(styles);

        return shouldRemoveSpacingOnMobile && isMobile && computedStyles
            ? omit(computedStyles, [...INNER_SPACING_STYLES, ...OUTER_SPACING_STYLES])
            : computedStyles;
    }, [shouldRemoveSpacingOnMobile, isMobile, styles]);
}
